<template>
  <div class="justify-content-center text-left dp02 p-3"
       v-show="loading || enabled">
    <div class="row col-12">
      <h3>
        Žádost o propojení s partnerem/partnerkou:
        <b-badge v-if="loading"
                 variant="light">
          <b-spinner variant="primary"></b-spinner>
          ... načítá se ...
        </b-badge>
        <b-badge v-else
                 :variant="status === 'ACCEPTED' ? 'success' : 'warning'">
          {{ $t(`customerRelationshipStatus.${status}`) }}
        </b-badge>
      </h3>
    </div>

    <div class="row col-12">
      <div class="col-2">
        <label for="fullName">{{ $t('fields.requestedPartnerFullName') }}:</label>
      </div>
      <div class="col-4">
        <b-form-input
          name="fullName"
          :disabled="true"
          :class="{ myInput: true }"
          v-model="fullName" />
      </div>
    </div>

    <div class="row col-12">
      <div class="col-2">
        <label for="email">{{ $t('fields.requestedPartnerEmail') }}:</label>
      </div>
      <div class="col-4">
        <b-form-input
          name="email"
          :disabled="true"
          :class="{ myInput: true }"
          v-model="email" />
      </div>
      <div v-if="infoText"
           class="col-auto">
        <b-alert show
                 variant="warning">
          <h3 class="mr-2"
              style="display: inline-block;">
            <font-awesome-icon class="fa-xs"
                               icon="exclamation-triangle" />
          </h3>
          <strong>{{ infoText }}</strong>
        </b-alert>
      </div>
    </div>

    <div class="row col-12">
      <div class="col-2">
        <label for="requestedAt">{{ $t('fields.requestedAt') }}:</label>
      </div>
      <div class="col-4">
        <b-form-input
          name="requestedAt"
          :disabled="true"
          :class="{ myInput: true }"
          v-model="requestedAt" />
      </div>
    </div>

    <div class="row col-12">
      <div class="col-2">
        <label for="acceptedAt">{{ $t('fields.acceptedAt') }}:</label>
      </div>
      <div class="col-4">
        <b-form-input
          name="acceptedAt"
          :disabled="true"
          :class="{ myInput: true }"
          v-model="acceptedAt" />
      </div>
    </div>

    <div class="row col-12">
      <div class="col-2">
        <label for="assignedCustomer">{{ $t('fields.assignedCustomer') }}:</label>
      </div>
      <div class="col-9">
        <CustomerPartnerCandidateInput
          :editable="status !== 'ACCEPTED'"
          name="assignedCustomer"
          :candidates="partnerCandidates"
          v-model="assignedCustomer" />
      </div>
      <div class="col-1">
        <b-button
          v-if="status !== 'ACCEPTED'"
          @click="accept"
          class="myButton align-middle">
          {{ $t("common.Assign") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import CustomerPartnerCandidateInput from '@components/input/CustomerPartnerCandidateInput';

export default {
  name: 'CustomerRelationship',
  components: { CustomerPartnerCandidateInput },
  props: {
    customerId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('editCustomerRelationship', ['enabled', 'status', 'partnerCandidates', 'requestedAt', 'acceptedAt', 'infoText']),
    fullName: {
      get() {
        return this.$store.state.editCustomerRelationship.partner.fullName;
      },
      set(val) {
        this.setPartnerFullName(val);
      }
    },
    email: {
      get() {
        return this.$store.state.editCustomerRelationship.partner.email;
      },
      set(val) {
        this.setPartnerEmail(val);
      }
    },
    assignedCustomer: {
      get() {
        return this.$store.state.editCustomerRelationship.assignedCustomer;
      },
      set(val) {
        this.setAssignedCustomer(val);
      }
    }
  },
  methods: {
    ...mapMutations({
      setPartnerFullName: 'editCustomerRelationship/setPartnerFullName',
      setPartnerEmail: 'editCustomerRelationship/setPartnerEmail',
      setAssignedCustomer: 'editCustomerRelationship/setAssignedCustomer'
    }),
    ...mapActions({
      fetchCustomerRelationship: 'editCustomerRelationship/getCustomerRelationship',
      acceptCustomerRelationship: 'editCustomerRelationship/acceptCustomerRelationship',
      resetContext: 'editCustomerRelationship/resetContext'
    }),
    accept() {
      this.acceptCustomerRelationship({ customerId: this.customerId });
    }
  },
  created() {
    this.loading = true;
    this.resetContext();
    this.fetchCustomerRelationship(this.customerId)
      .then(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
.alert {
  margin-bottom: 1px;
  height: 40px;
  line-height: 40px;
  padding: 0px 15px;
}
</style>
